const TAB_ROOT_SELECTOR = '[data-ms-tabs]';

function activateTab(root, tab) {
  const tabs = [...root.querySelectorAll('[role="tab"]')];
  const panels = [...root.querySelectorAll('[role="tabpanel"]')];
  const target = tab.dataset.msTab;

  tabs.forEach((item) => {
    const selected = item === tab;
    item.setAttribute('aria-selected', selected ? 'true' : 'false');
    item.tabIndex = selected ? 0 : -1;
  });

  panels.forEach((panel) => {
    panel.hidden = panel.dataset.msPanel !== target;
  });
}

function connectTabs(root) {
  if (root.dataset.msTabsConnected === 'true') return;

  const tabs = [...root.querySelectorAll('[role="tab"]')];
  const panels = [...root.querySelectorAll('[role="tabpanel"]')];
  const tabList = root.querySelector('[data-ms-tab-list]');
  if (!tabList || tabs.length === 0 || tabs.some((tab) => !panels.some((panel) => panel.dataset.msPanel === tab.dataset.msTab))) return;

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(root, tab));
    tab.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let nextIndex = index;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      activateTab(root, tabs[nextIndex]);
      tabs[nextIndex].focus();
    });
  });

  const initialTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
  activateTab(root, initialTab);
  root.dataset.msTabsConnected = 'true';
  tabList.hidden = false;
}

function connectProductPage(scope = document) {
  if (scope.matches?.(TAB_ROOT_SELECTOR)) connectTabs(scope);
  scope.querySelectorAll(TAB_ROOT_SELECTOR).forEach(connectTabs);
}

connectProductPage();

document.addEventListener('shopify:section:load', (event) => {
  connectProductPage(event.target);
});
